<template>
  <div class="flex flex-col gap-y-3">
    <div class="flex items-center justify-between border-b border-brand-gray-350 w-full mb-4">
      <div class="pb-2 w-full">
        <h2 class="text-xl text-gray-700 font-normal mx-3">
          {{ $t('delegateCard') }}
        </h2>
      </div>
    </div>
    <div
      class="infobar px-3 py-2 rounded-md border flex items-start gap-x-3 text-white border-sky-500 bg-sky-400"
    >
      <div class="w-12 h-12 flex justify-center items-center">
        <faInfoCircle class="w-9 fill-white" />
      </div>
      <span>{{ $t('DelegateCardMSG') }}</span>
    </div>

    <DataTable
      :default-headers="[
        'unifiedNumber',
        'PRONameAr',
        'PRONameEn',
        'cardIssueDate',
        'cardExpiryDate',
        'PROStatus'
      ]"
      :rows="delegateInfo"
    >
    </DataTable>
  </div>
</template>

<script setup>
import faInfoCircle from '@/assets/icons/faInfoCircle.svg?component'
import { onMounted, ref, computed, nextTick } from 'vue'
import authService from '@/services/auth'
import client_lookups from '@/assets/json/clientLookups.json'
import axiosInstance from '@/services'
import { useRoute } from 'vue-router'
import DataTable from '@/components/DataTable/index.vue'

const route = useRoute()
const userProfile = ref()
const estInfo = ref()

const viewChildrenList = ref(false)

const {
  establishmentAccountTypes: { freeZone, holding }
} = client_lookups

const delegateInfo = computed(() => {
  if (!estInfo.value?.delegateCard) return []
  return estInfo.value?.delegateCard.map((d) => {
    return {
      unifiedNumber: d.personUnifiedNumber,
      PRONameAr: d.arabicPersonName,
      PRONameEn: d.englishPersonName,
      cardIssueDate: d.delegateCardIssueDate,
      cardExpiryDate: d.delegateCardExpiryDate,
      PROStatus: d.proStatus == 1 ? 'proActive' : 'proInactive'
    }
  })
})

onMounted(async () => {
  await nextTick()
  userProfile.value = await authService.getProfile()

  const { isAuthorityEstablishment, accountTypeId } = userProfile.value

  if ([freeZone, holding].includes(accountTypeId)) {
    viewChildrenList.value = true
  }

  await fetchDelegateCards()
})

async function fetchDelegateCards() {
  const params = {
    delegateCardStatus: 1
  }
  if (route.query?.childEstablishmentId) {
    params.establishmentId = route.query?.childEstablishmentId
  }

  estInfo.value = await axiosInstance.get('/api/establishment/delegateCardInfo/', { params })
}
</script>

<style lang="scss" scoped></style>
